import React from "react";
import { Helmet } from 'react-helmet-async';
import { Calendar, ArrowRight, Megaphone } from "lucide-react";

// 静的なお知らせデータ
const newsData = [
  {
    id: 1,
    title: "JOYBASEベータ版がリリースされました",
    date: "2025/10/31",
    category: "リリース",
    badge: "NEW",
    badgeColor: "bg-red-400",
    summary: "JOYBASEのベータ版がリリースされました。初期費用0円、月額費用0円でオリパストアを開設できます。",
    slug: "joybase-beta-release"
  }
];

const NewsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>お知らせ</title>
        <meta name="description" content="JOYBASEからの最新情報・お知らせ一覧です。" />
      </Helmet>

      <div className="min-h-screen bg-theme-bg">
        <div className="pt-20">
          <div className="max-w-screen-lg mx-auto px-4 py-8">
            {/* ヘッダー */}
            <div className="mb-8">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-orange-400 border-theme rounded-theme flex items-center justify-center shadow-theme-sm">
                  <Megaphone className="w-5 h-5 text-black" />
                </div>
                <h1 className="text-3xl [font-weight:var(--theme-font-weight)] text-theme-bg-text">お知らせ</h1>
              </div>
              <p className="[font-weight:var(--theme-font-weight-button)] text-theme-bg-text opacity-70">JOYBASEからの最新情報をお届けします</p>
            </div>

            {/* お知らせ一覧 */}
            <div className="space-y-4">
              {newsData.map((news) => (
                <a
                  key={news.id}
                  href={`/news/${news.slug}`}
                  className="block bg-white border-theme rounded-theme-lg shadow-theme hover:shadow-theme-hover hover:translate-x-[2px] hover:translate-y-[2px] transition-all p-4 sm:p-6"
                >
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center gap-3">
                      {news.badge && (
                        <span className={`inline-block px-3 py-1 ${news.badgeColor} border-theme text-black text-xs [font-weight:var(--theme-font-weight)] rounded-theme`}>
                          {news.badge}
                        </span>
                      )}
                      <span className="px-2 py-1 bg-gray-100 border-theme rounded-theme text-xs [font-weight:var(--theme-font-weight-button)]">{news.category}</span>
                    </div>
                    <div className="flex items-center gap-1 text-sm [font-weight:var(--theme-font-weight-button)] text-gray-600">
                      <Calendar size={14} />
                      {news.date}
                    </div>
                  </div>

                  <h2 className="text-xl [font-weight:var(--theme-font-weight)] text-black mb-2">{news.title}</h2>
                  <p className="[font-weight:var(--theme-font-weight-button)] text-gray-600 mb-4">{news.summary}</p>

                  <div className="flex items-center gap-1 text-theme-primary [font-weight:var(--theme-font-weight)] text-sm hover:opacity-80">
                    詳しく見る
                    <ArrowRight size={16} />
                  </div>
                </a>
              ))}
            </div>

            {/* 空状態（将来的にページネーション追加時に使用） */}
            {newsData.length === 0 && (
              <div className="bg-white border-theme rounded-theme-lg shadow-theme p-12 text-center">
                <p className="[font-weight:var(--theme-font-weight-button)] text-gray-600">お知らせはまだありません</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsPage;
